require('./src/global.css')

const addScript = url => {
  const script = document.createElement('script')
  script.src = url
  document.getElementsByTagName(`head`)[0].appendChild(script)
}

// Initialize ServiceTitan DNI
let dniInitialized = false
const initServiceTitanDNI = () => {
  if (typeof window === 'undefined' || dniInitialized) return

  window.dni = (function (q, w, e, r, t, y, u) {
    q['ServiceTitanDniObject'] = t
    q[t] =
      q[t] ||
      function () {
        ;(q[t].q = q[t].q || []).push(arguments)
      }
    q[t].l = 1 * new Date()
    y = w.createElement(e)
    u = w.getElementsByTagName(e)[0]
    y.async = true
    y.src = r
    u.parentNode.insertBefore(y, u)
    return q[t]
  })(window, document, 'script', 'https://static.servicetitan.com/marketing-ads/dni.js', 'dni')

  window.dni('init', '908677045')
  dniInitialized = true
}

// eslint-disable-next-line no-unused-vars
exports.onRouteUpdate = s => {
  //addScript(`//scripts.iconnode.com/${process.env.GATSBY_WHATCONVERTS_NUMBER}.js`)
  addScript(process.env.GATSBY_BIRDEYE_REVIEW_URL)

  // Initialize ServiceTitan DNI on first load
  if (!dniInitialized) {
    initServiceTitanDNI()
  }

  // Call dni load on each route update
  if (typeof window !== 'undefined' && window.dni) {
    window.dni('load')
  }
}
